import {FC} from "react";
import {SectionHeader} from "~src/shared/form/shared.sc";
import {useTranslation} from "react-i18next";
import {TileContainerExt} from "~src/modules/companySettings/shared.sc";
import {apiConfig} from "../../../../config/server/server.index";
import {AuthorizedDownload} from "~src/modules/companySettings/components/AuthorizedDownload";
import {useIsoDateFormatter} from "~src/services/hooks/useDateFormatter";
import styled from "styled-components";

export const Subsection = styled.div`
  margin-top: 15px;
`;

export const ExportUsersWithOtp: FC = () => {
  const [t] = useTranslation();
  const f = useIsoDateFormatter();
  return <TileContainerExt>
    <SectionHeader $inTile data-translation="x.company.export_otps.title">
      {t('x.company.export_users.title')}
    </SectionHeader>

    <Subsection>
    <AuthorizedDownload
      filename={`${f(new Date())}_user_otps.csv`}
      icon={'iconCsv'}
      labelKey={'x.company.export_otps.description'}
      method={'POST'}
      url={apiConfig.userServiceApi.base_url + '/otps'}
    />
    </Subsection>
  <Subsection>
    <AuthorizedDownload
      filename={`${f(new Date())}_users.csv`}
      icon={'iconCsv'}
      labelKey={'x.company.export_users.description'}
      url={apiConfig.userServiceApi.base_url + '/users'}
    />
  </Subsection>

  </TileContainerExt>
};
